import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Popover — a panel that opens from a control and stays open while it is
 * used (ADR-0088 D2): Admin's and Manager's pickers, Manager's month picker
 * and account panel, and a field's help.
 *
 * Built on Base UI (ADR-0088 D3), replacing the Radix popovers of Admin and
 * Manager. Positioning, focus moved in on open and back on close, Escape and
 * a click outside come from Base UI. A searchable list inside it keeps its
 * own listbox semantics (Admin's `listbox.tsx`, roster-list's
 * `ListboxSearch`); the popover is the layer, not the list.
 *
 * The content opens below its trigger, aligned to its start, 4 px away. A
 * popup matched to its trigger's width uses `w-(--anchor-width)`, the width
 * Base UI sets on the popover, where Radix's was
 * `--radix-popover-trigger-width`.
 */
import { Popover as PopoverPrimitive } from '@base-ui/react/popover';
import { forwardRef } from 'react';
import { asChildProps } from './as-child.js';
import { cn } from './cn.js';
import { floatingMotion } from './overlay-shape.js';
export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = forwardRef(({ asChild, children, ...props }, ref) => (_jsx(PopoverPrimitive.Trigger, { ref: ref, "data-slot": "popover-trigger", ...props, ...asChildProps({ asChild, children }) })));
PopoverTrigger.displayName = 'PopoverTrigger';
export const PopoverClose = forwardRef(({ asChild, children, ...props }, ref) => (_jsx(PopoverPrimitive.Close, { ref: ref, "data-slot": "popover-close", ...props, ...asChildProps({ asChild, children }) })));
PopoverClose.displayName = 'PopoverClose';
export const PopoverContent = forwardRef(({ className, side = 'bottom', align = 'start', sideOffset = 4, alignOffset, collisionPadding, anchor, ...props }, ref) => (_jsx(PopoverPrimitive.Portal, { children: _jsx(PopoverPrimitive.Positioner, { className: "z-50", side: side, align: align, sideOffset: sideOffset, alignOffset: alignOffset, collisionPadding: collisionPadding, anchor: anchor, children: _jsx(PopoverPrimitive.Popup, { ref: ref, "data-slot": "popover-content", className: cn('rounded-token-card border border-border-default bg-surface-card text-text-primary shadow-menu outline-none', floatingMotion, className), ...props }) }) })));
PopoverContent.displayName = 'PopoverContent';
//# sourceMappingURL=popover.js.map